module.exports = __webpack_public_path__ + "img/157.d998147d.png";